// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";
import { DOCUMENT_COMPONENT_TYPES } from "../../../constants/document";

export default function SignTagPropertiesBtn({ section, handleButtonClick }) {
  if (
    (section &&
      (section.type === DOCUMENT_COMPONENT_TYPES.SIGNATURE_CHECKBOX ||
        section.type === DOCUMENT_COMPONENT_TYPES.SIGNATURE_TEXT)) ||
    (section &&
      section.type === DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER &&
      section.data &&
      section.data.signer_config &&
      (section.data.signer_config.tag_type === "signtext" ||
        section.data.signer_config.tag_type === "signcheckbox"))
  ) {
    return (
      <Tooltip placement="top" overlay="Settings" align={{ offset: [0, 6] }}>
        <span
          data-test="documentitems-sign-tag-properties"
          className="btn-icon"
          id="sign-tags-properties-btn"
          onMouseDown={() => {
            handleButtonClick(section.data.signer_config.tag_id);
          }}
          role="button"
          tabIndex={0}>
          <FontAwesomeIcon icon={["far", "sliders"]} />
        </span>
      </Tooltip>
    );
  }
  return null;
}
